/* OCB: send the optional birthday to Klaviyo when a theme sign-up form is submitted. */
(function () {
  var COMPANY = 'VSXM2u';
  document.addEventListener('submit', function (e) {
    var form = e.target, box = form.querySelector && form.querySelector('[data-ocb-bday]');
    if (!box) return;
    var m = box.querySelector('[data-bday-month]').value, d = box.querySelector('[data-bday-day]').value;
    var email = (form.querySelector('input[type=email]') || {}).value;
    if (!m || !d || !email) return;
    try {
      fetch('https://a.klaviyo.com/client/profiles/?company_id=' + COMPANY, {
        method: 'POST', keepalive: true,
        headers: { 'content-type': 'application/vnd.api+json', 'revision': '2025-07-15' },
        body: JSON.stringify({ data: { type: 'profile', attributes: { email: email.trim(), properties: { birthday: '2000-' + m + '-' + d } } } })
      });
    } catch (err) {}
  }, true);
})();
